import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/**
 * Data-grid loading overlay: a thin progress bar along the top and a message in the middle, worded
 * and styled like the dashboard's "Loading efforts summary..." banner. Shown while a grid's rows are
 * being fetched, in place of the "No rows" an empty grid would otherwise show.
 *
 * Pass it through the grid's slots with the message in slotProps.loadingOverlay.
 * @since NEXT_VERSION
 */
export const GridLoadingMessageOverlay = ({ message = "Loading data..." }) => (
  <MDBox sx={{ position: "relative", height: "100%" }}>
    <LinearProgress sx={{ position: "absolute", top: 0, left: 0, right: 0 }} />
    <MDBox height="100%" display="flex" justifyContent="center" alignItems="center" px={2}>
      <MDTypography variant="h6" color="info" fontWeight="medium" role="status">
        {message}
      </MDTypography>
    </MDBox>
  </MDBox>
);

GridLoadingMessageOverlay.propTypes = {
  message: PropTypes.string,
};
